/* eslint-disable no-undef */
import { styled } from '@mui/material';

export const Styles = {
  BannerWrapper: styled('div')<{
    width: number;
    height: number;
    border?: boolean;
    src: string;
    href?: string;
  }>(({ width, height, src }) => ({
    width: `${width}px`,
    height: `${height}px`,
    background: `url(${src}) no-repeat center center`,
    backgroundSize: 'cover',
    boxSizing: 'border-box'
  })),

  // TopBanner: styled('div')(({ theme }) => ({
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   width: '100%',
  //   maxWidth: '1180px',
  //   margin: '0 auto 10px',
  //   padding: '0 10px',
  //   [theme.breakpoints.down('md')]: {
  //     margin: '20px auto',
  //     maxWidth: '50%'
  //   }
  // })),

  BannerContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '1180px',
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      padding: '0 5px'
    }
  })),

  BannerRow: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '30px',
    width: '100%',
    maxWidth: '1200px',
    marginTop: '5px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '15px',
      margin: '15px 0',
      padding: '0 10px',
      '& > div': {
        width: '100%',
        maxWidth: '100%',
        margin: '0 auto'
      }
    },
    [theme.breakpoints.down('sm')]: {
      gap: '12px',
      margin: '10px 0'
    }
  })),

  BannerItem: styled('div')(({ theme }) => ({
    flex: 1,
    minWidth: 0, // Permite que os itens encolham
    transition: 'transform 0.3s ease',
    borderRadius: '8px',
    overflow: 'hidden',
    // boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    '&:hover': {
      transform: 'translateY(-3px)'
    },
    [theme.breakpoints.down('md')]: {
      boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
      '&:hover': {
        transform: 'none'
      }
    }
  }))
};
